module.exports = __webpack_public_path__ + "img/notifications.a86d7abe.svg";